const CURSORTYPE = {
  north: 'n-resize',
  south: 's-resize',
  west: 'w-resize',
  east: 'e-resize',
  northeast: 'ne-resize',
  northwest: 'nw-resize',
  southwest: 'sw-resize',
  southeast: 'se-resize',
  initial: 'initial'
}
// 拉伸光标的范围大小
const range = 8
// 获取盒子相对于body的坐标
function getPosition(e) {
  if (e) {
    const offsetLeft = e.offsetLeft
    const offsetTop = e.offsetTop
    const parentPosition = getPosition(e.offsetParent)
    return {
      x: offsetLeft + parentPosition.x,
      y: offsetTop + parentPosition.y
    }
  }
  return { x: 0, y: 0 }
}
// 获取拉伸状态
function getResizerType(obj) {
  const { mouseX, mouseY, x, y, width, height } = obj
  let type = 'initial'
  if (mouseX > x + width - range && mouseY <= y + height - range && y + range <= mouseY) {
    type = 'east' // 右
  } else if (x + range > mouseX && mouseY <= y + height - range && y + range <= mouseY) {
    type = 'west' // 左
  } else if (mouseY > y + height - range && mouseX <= x + width - range && x + range <= mouseX) {
    type = 'south' // 下
  } else if (y + range > mouseY && mouseX <= x + width - range && x + range <= mouseX) {
    type = 'north' // 上
  } else if (mouseX > x + width - range && mouseY > y + height - range) {
    type = 'southeast' // 右下
  } else if (x + range > mouseX && mouseY > y + height - range) {
    type = 'southwest' // 左下
  } else if (y + range > mouseY && mouseX > x + width - range) {
    type = 'northeast' // 右上
  } else if (y + range > mouseY && x + range > mouseX) {
    type = 'northwest' // 左上
  }
  return type
}
// 上拉伸
function resizeTop(el, info, moveY) {
  const { height, offsetTop, maxTop, maxHeight, minHeight, isInside, minTop } = info
  const _maxHeight = isInside ? Math.min(height + offsetTop, maxHeight) : maxHeight
  // 最小高度不能小于样式设置的最小高度，最大高度不超过设置的最大高度
  // 如果配置了inside，则不能超过该拉伸方向在边界内剩余的可拉伸宽度
  const _height = Math.max(Math.min(height - moveY, _maxHeight), minHeight)
  const _top = Math.min(Math.max(offsetTop + (height - _height), minTop), maxTop)
  el.style.height = `${_height}px`
  el.style.top = `${_top}px`
}
// 下拉伸
function resizeBottom(el, info, moveY) {
  const { height, offsetTop, minHeight, parentEl, maxHeight, isInside } = info
  const _maxHeight = isInside ? Math.min(parentEl.clientHeight - offsetTop, maxHeight) : maxHeight
  const _height = Math.max(Math.min(height + moveY, _maxHeight, maxHeight), minHeight)
  el.style.height = `${_height}px`
}
// 左拉伸
function resizeLeft(el, info, moveX) {
  const { width, offsetLeft, maxLeft, maxWidth, minWidth, isInside, minLeft } = info
  const _maxWidth = isInside ? Math.min(width + offsetLeft, maxWidth) : maxWidth
  const _width = Math.max(Math.min(width - moveX, _maxWidth), minWidth)
  const _left = Math.min(Math.max(offsetLeft + (width - _width), minLeft), maxLeft)
  el.style.width = `${_width}px`
  el.style.left = `${_left}px`
}
// 右拉伸
function resizeRight(el, info, moveX) {
  const { width, offsetLeft, parentEl, maxWidth, minWidth, isInside } = info
  const _maxWidth = isInside ? Math.min(parentEl.clientWidth - offsetLeft, maxWidth) : maxWidth
  const _width = Math.max(Math.min(width + moveX, _maxWidth, maxWidth), minWidth)
  el.style.width = `${_width}px`
}
export default {
  bind(boxEl, { modifiers }) {
    // 是否只在拉伸
    const isInside = modifiers['inside']
    let keys = Object.keys(CURSORTYPE).filter(v => modifiers[v] && v !== 'initial')
    if (!keys.length) {
      keys = Object.keys(CURSORTYPE)
    }
    const onmousemove = (e) => {
      const position = Object.assign({ mouseX: e.clientX, mouseY: e.clientY, height: boxEl.offsetHeight, width: boxEl.offsetWidth }, getPosition(boxEl))
      const type = getResizerType(position)
      if (type !== 'initial' && keys.indexOf(type) !== -1) {
        boxEl.style.cursor = CURSORTYPE[type]
        boxEl.setAttribute('isResizer', 'true')
      } else {
        boxEl.setAttribute('isResizer', 'false')
        // 从dragCursor上取值
        boxEl.style.cursor = boxEl.getAttribute('dragCursor') || ''
      }
    }
    const onmousedown = (e) => {
      // 盒子高度
      const height = boxEl.offsetHeight
      // 盒子宽度
      const width = boxEl.offsetWidth
      // 上偏移
      const offsetTop = boxEl.offsetTop
      // 左偏移
      const offsetLeft = boxEl.offsetLeft
      // 盒子设置的最小高度
      const minHeight = Number.parseFloat(getComputedStyle(boxEl).minHeight) || 0
      // 盒子设置的最小宽度
      const minWidth = Number.parseFloat(getComputedStyle(boxEl).minWidth) || 0
      // 盒子设置的最大高度
      const maxHeight = Number.parseFloat(getComputedStyle(boxEl).maxHeight) || Number.MAX_SAFE_INTEGER
      // 盒子设置的最大宽度
      const maxWidth = Number.parseFloat(getComputedStyle(boxEl).maxWidth) || Number.MAX_SAFE_INTEGER
      // 最大top值
      const maxTop = offsetTop + (height - minHeight)
      // 最大left值
      const maxLeft = offsetLeft + (width - minWidth)
      // 最小top值
      const minTop = isInside ? 0 : Number.MIN_SAFE_INTEGER
      // 最小left值
      const minLeft = isInside ? 0 : Number.MIN_SAFE_INTEGER
      const resizeInfo = Object.assign({ parentEl: boxEl.offsetParent || document.documentElement, mouseX: e.clientX, mouseY: e.clientY, // 鼠标Y坐标
        height,
        width,
        offsetLeft,
        offsetTop,
        minHeight,
        minWidth,
        maxWidth,
        maxHeight,
        maxTop,
        maxLeft,
        isInside,
        minTop,
        minLeft }, getPosition(boxEl))
      const type = getResizerType(resizeInfo)
      const docMove = (e) => {
        const moveX = e.clientX - resizeInfo.mouseX // 鼠标移动的x轴距离
        const moveY = e.clientY - resizeInfo.mouseY // 鼠标移动的Y轴距离
        window.requestAnimationFrame(() => {
          if (type === 'north') { // 上
            resizeTop(boxEl, resizeInfo, moveY)
          } else if (type === 'south') { // 下
            resizeBottom(boxEl, resizeInfo, moveY)
          } else if (type === 'west') { // 左
            resizeLeft(boxEl, resizeInfo, moveX)
          } else if (type === 'east') { // 右
            resizeRight(boxEl, resizeInfo, moveX)
          } else if (type === 'southeast') { // 右下
            resizeBottom(boxEl, resizeInfo, moveY)
            resizeRight(boxEl, resizeInfo, moveX)
          } else if (type === 'northeast') { // 右上
            resizeTop(boxEl, resizeInfo, moveY)
            resizeRight(boxEl, resizeInfo, moveX)
          } else if (type === 'northwest') { // 左上
            resizeTop(boxEl, resizeInfo, moveY)
            resizeLeft(boxEl, resizeInfo, moveX)
          } else if (type === 'southwest') { // 左下
            resizeBottom(boxEl, resizeInfo, moveY)
            resizeLeft(boxEl, resizeInfo, moveX)
          }
        })
      }
      const onmouseup = () => {
        document.removeEventListener('mousemove', docMove, false)
        document.removeEventListener('mouseup', onmouseup, false)
        document.body.style.userSelect = ''
      }
      if (type !== 'initial' && keys.indexOf(type) !== -1) {
        document.body.style.userSelect = 'none'
        document.addEventListener('mousemove', docMove, false)
      }
      document.addEventListener('mouseup', onmouseup, false)
    }
    boxEl.addEventListener('mousemove', onmousemove, false)
    boxEl.addEventListener('mousedown', onmousedown, false)
  }
}
